/* jscs:disable */
/* jshint ignore:start */
// QueryData.js - Created by Stephen Morley and released under the terms of the CC0 1.0 Universal legal code:
function QueryString() {var a=location.search||"";"?"==a.charAt(0)&&(a=a.substring(1));if (a.length)for (var a=a.replace(/\+/g," "),a=a.split(/[&;]/g),c=0;c<a.length;c++){var b=a[c].split("="),d=decodeURIComponent(b[0]),b=1<b.length?decodeURIComponent(b[1]):"";this[d]=b}};
window.QueryString = QueryString;
/* jshint ignore:end */
/* jscs:enable */

/* globals QueryString, io */

var controller = window.controller = {
	namespace: '/game',
};

$.ready(function () {
	controller.socket = io.connect(controller.namespace);
	
	controller.socket.on('connect', function () {
		var querystring = new QueryString();
		
		var request = { engine: game.attr('data-engine'), game: game.attr('data-game'), playerid: querystring.playerid };
		
		if (!request.playerid && querystring.cycleid) {
			delete request.playerid;
			request.cycleid = querystring.cycleid;
		}
		
		controller.socket.emit('open', request);
	});
	
	controller.socket.on('reconnect', function () {
		if (game.panel.dialog._content && game.panel.dialog._content.slug === 'disconnect') {
			game.panel.dialog.hide();
		}
	});
	
	controller.socket.on('disconnect', function () {
		game.panel.dialog.show('disconnect');
	});
	
	controller.socket.on('notice', function (response) {
		controller.error = response;
		game.panel.dialog.show(response.slug);
		game.panel.reable();
	});
	
	controller.socket.on('fatal', function (response) {
		console.log('fatal', response);
		controller.error = response;
		game.panel.dialog.show('fatal');
	});
	
	controller.socket.on('error', function (response) {
		console.log('error', response);
		controller.error = response;
		game.panel.dialog.show('fatal');
	});
});



/** WEBPACK FOOTER **
 ** ./../../../../engine/public-src/common/controller/controller.js
 **/